import React, { useState, useContext, useEffect }  from 'react'
import { Button ,Form , Row, Col} from 'react-bootstrap'
import { useHistory,useParams } from 'react-router-dom'
import "./FAQcreate.css"
import { getfaq, updatefaq } from '../Network/FAQ'
import { Loading, HeaderTitle } from '../Library'
import { LanguageContext } from '../Language/LanguageContext'
import { NotifyContext } from '../Library/Notify'
import { setDocumentTitle } from '../AppTitle'

function FAQEdit() {
    const history = useHistory();
    const langCx = useContext(LanguageContext);
    const lang = langCx.lang.FAQ;
    const langError = langCx.lang.error;
    const notifyCx = useContext(NotifyContext);
    const { id } = useParams();

    const [question, setQuestion] = useState("");
    const [answer, setAnswer] = useState("");
    const [isLoading, setLoading] = useState(false);
    const [isError, setError] = useState(false);

    useEffect(() => {
        setDocumentTitle("Edit FAQ")
        const fetchData = () =>{
            setLoading(true)
            getfaq(id,
                (data)=>{
                    setQuestion(data.question)
                    setAnswer(data.answer)
                    setLoading(false)
                },
                (error)=>{
                    setLoading(false);
                    notifyCx.showNotify("Error get FAQ information", error.message, 2)
                })
        }
        fetchData()
    }, [])
    
    const onSubmit = () =>{
        if( !question || !answer ){ 
            notifyCx.showNotify(lang.not_complete, lang.not_complete_desc, 1)
            setError(true);
            return;
        }

        setLoading(true);
        updatefaq(
            id,
            question,
            answer,
            ()=>{
                setLoading(false)
                notifyCx.showNotify(
                    lang.edited_faq,
                    lang.edit_complete_desc,
                    0)
                history.goBack()
            },
            (error)=>{
                setLoading(false)
                notifyCx.showNotify("Error", error.message, 2)
            }
        )
    }
    
   
    return (
        // <>
        // { isLoading ? <Loading title={lang.creating}/>: null }
        <div id="faqcreate">
            <HeaderTitle title={lang.edit_faq} isShowBack backTo="/faq"/>
                <Row style={{width: "100%"}}>
                    <Col className="content-container" md={10} lg={8} xl={6}>
                        <Form
                            onSubmit={(e)=>{
                                e.preventDefault();
                                onSubmit();
                            }}
                        >
                            <Form.Label  className = "Question-label">{lang.question}</Form.Label>
                            <Form.Control 
                                className = "Question-form" 
                                value={question}
                                isInvalid={isError && !question}
                                onChange={(e)=>setQuestion(e.target.value)} 
                            />
                            <Form.Label className = "Answer-label">{lang.answer}</Form.Label>
                            <Form.Control className = "Answer-form" 
                                value={answer}
                                isInvalid={isError && !answer}
                                onChange={(e)=>setAnswer(e.target.value)} />
                            <Button type="submit" className = "add-button">
                                {lang.edit_button} 
                            </Button>
                        </Form>
                    </Col>
                </Row>
        </div>
    )
}

export default FAQEdit